import { render } from "./FileChat.vue?vue&type=template&id=8cbadec6&scoped=true"
import script from "./FileChat.vue?vue&type=script&lang=js"
export * from "./FileChat.vue?vue&type=script&lang=js"

import "./FileChat.vue?vue&type=style&index=0&id=8cbadec6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cbadec6"]])

export default __exports__